import { useTranslation } from 'react-i18next';
import type { WithdrawalStatus } from '@shared/api/contracts';
import { getWithdrawalStatusVariant, WITHDRAWAL_STATUS_VARIANT_CLASSES, withdrawalStatusLabelKey } from '../lib/status';
import { adminStateLabelKey, isCanonicalWithdrawalState, merchantStageLabelKey } from '../lib/state-view';
import { cn } from '@shared/lib/utils';

interface WithdrawalStatusBadgeProps {
  status: WithdrawalStatus | string;
  state?: string | null;
  audience?: 'merchant' | 'admin';
  className?: string;
}

export function WithdrawalStatusBadge({ status, state, audience = 'merchant', className }: WithdrawalStatusBadgeProps) {
  const { t } = useTranslation('cabinet');
  const resolvedState = state ?? (audience === 'admin' && isCanonicalWithdrawalState(status) ? status : null);
  const variant = getWithdrawalStatusVariant(resolvedState || status);
  const labelKey = resolvedState || audience === 'admin'
    ? (audience === 'admin' ? adminStateLabelKey(resolvedState, status) : merchantStageLabelKey(resolvedState, status))
    : withdrawalStatusLabelKey(status);
  const label = t(labelKey, { defaultValue: status });

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        WITHDRAWAL_STATUS_VARIANT_CLASSES[variant],
        className
      )}
    >
      {label}
    </span>
  );
}
